exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.GsoOY-VyldQeGlUHF8fc2{background:linear-gradient(315deg, #0070ce 0%, #00baff 100%);height:initial;padding-bottom:3.125rem}.GsoOY-VyldQeGlUHF8fc2 .actionButtons{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:2rem}.GsoOY-VyldQeGlUHF8fc2 .backButton{background-color:#fff;font-size:1.5rem;color:#00baff}\n", ""]);

// exports
exports.locals = {
	"header": "GsoOY-VyldQeGlUHF8fc2"
};